
import { defineComponent, onMounted } from 'vue';
import { AppTable, AppCard, AppButton } from '@/components';
import { TableColumnType, TableConfig } from '@/components/table/types';
import { useArenaTicketList } from '@/modules/arena/ticket/model/index';
import { ArenaTicketTypeList } from '@/modules/arena/ticket/model/mixins';
import { ROUTE_NAME_ARENA } from '@/modules/arena/router';
import { ROUTE_NAME_PROMOTION } from '@/modules/promotion/router';
import { InjectionFeature } from '@/common/reward/types';
import { ROUTE_NAME_ITEM } from '@/modules/item/router';

export default defineComponent({
    name: ROUTE_NAME_ARENA.TICKET.INDEX,
    components: { AppTable, AppCard, AppButton },
    setup() {
        const { list, total, fetchList, actions } = useArenaTicketList();

        const table: TableConfig = {
            columns: [
                { type: TableColumnType.Index, label: '#' },
                { type: TableColumnType.Option, label: 'Type', key: 'type', options: ArenaTicketTypeList },
                { type: TableColumnType.Text, label: 'Name', key: 'name' },
                { type: TableColumnType.Actions, label: 'Actions' }
            ],
            actions: [
                {
                    props: (row: any) => ({
                        icon: 'fa-shipping-fast',
                        theme: 'info',
                        tooltip: 'Add special shop',
                        to: {
                            name: ROUTE_NAME_ITEM.SYSTEM.ADD,
                            query: { feature: InjectionFeature.ArenaTicket, data: row.type }
                        }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-tags',
                        theme: 'info',
                        tooltip: 'Add promo code',
                        to: {
                            name: ROUTE_NAME_PROMOTION.CODE.ADD,
                            query: { feature: InjectionFeature.ArenaTicket, data: row.type }
                        }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-edit',
                        theme: 'info',
                        tooltip: 'Edit',
                        to: { name: ROUTE_NAME_ARENA.TICKET.EDIT, params: { type: row.type } }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-trash-alt',
                        theme: 'danger',
                        tooltip: 'Delete',
                        disabled: !row.canDelete,
                        onClick: () => actions.remove(row.type)
                    }),
                    group: 1
                }
            ]
        };

        onMounted(fetchList);

        return { table, list, total, fetchList, ROUTE_NAME_ARENA };
    }
});
